import { render } from "./KSMoveKeysFromFilter.vue?vue&type=template&id=3b8e8aea"
import script from "./KSMoveKeysFromFilter.vue?vue&type=script&lang=js"
export * from "./KSMoveKeysFromFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__